import graphqlClient from "../../../apollo";

class PlanProvider {

    fetchPlanes() {
        return graphqlClient.query({
            query: require('./gql/adminPlanFetch.graphql'),
            fetchPolicy: "network-only"
        })
    }

    findPlan(id) {
        return graphqlClient.query({
            query: require('./gql/adminPlanFind.graphql'),
            variables: { id },
            fetchPolicy: "network-only"
        })
    }

    createPlan(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/adminPlanCreate.graphql'),
            variables: { input: form },
            refetchQueries: [{ query: require('./gql/adminPlanFetch.graphql') }]
        })
    }

    updatePlan(form) {
        const { id, ...input } = form;
        return graphqlClient.mutate({
            mutation: require('./gql/adminPlanUpdate.graphql'),
            variables: { id, input },
            refetchQueries: [{ query: require('./gql/adminPlanFetch.graphql') }]
        })
    }

    deletePlan(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/adminPlanDelete.graphql'),
            variables: { id },
            refetchQueries: [{ query: require('./gql/adminPlanFetch.graphql') }]
        })
    }
}

export default new PlanProvider()
